import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitotelanganacabservice() {



  const cardData = {
    keyword: " Mumbai to Telangana Cab Service",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Telangana cab service, providing safe, comfortable, and affordable long-distance interstate travel for families, corporate travelers, students, and pilgrimage groups. Telangana is a major destination from Mumbai, especially Hyderabad and surrounding cities, and the journey covers approximately 700–800 km via well-developed national highways. Our professional drivers ensure a smooth, secure, and stress-free road trip with planned rest stops and door-to-door pickup and drop service. We offer flexible options including one-way drops, round trips, and customized multi-city travel itineraries. Our fleet includes economy sedans, premium sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Telangana cab service.",

"topPlaces": [
  {
    "title": "Hyderabad – Charminar",
    "description": "Charminar is the most iconic landmark of Hyderabad and a symbol of the city’s rich history, built in 1591 by Muhammad Quli Qutb Shah. It stands at the heart of the old city surrounded by bustling markets like Laad Bazaar, famous for bangles, pearls, and traditional shopping. Travelers arriving from Mumbai by cab often visit Charminar first to experience Hyderabad’s vibrant street culture, historical architecture, and energetic atmosphere filled with food stalls and heritage sites."
  },
  {
    "title": "Hyderabad – Golconda Fort",
    "description": "Golconda Fort is a magnificent historical fortress known for its grand architecture, acoustic system, and panoramic views of Hyderabad city. Once the capital of the Qutb Shahi dynasty, it features massive stone gates, royal halls, and ancient pathways. It is a must-visit attraction for road travelers exploring Telangana, offering a deep dive into the region’s royal past and architectural brilliance."
  },
  {
    "title": "Hyderabad – Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake connecting Hyderabad and Secunderabad, famous for the massive Buddha statue placed at its center. It is a peaceful and scenic destination ideal for evening walks, boating, and city skyline views. After a long journey from Mumbai, it serves as a relaxing leisure spot for tourists."
  },
  {
    "title": "Hyderabad – Ramoji Film City",
    "description": "Ramoji Film City is one of the largest film studio complexes in the world and a major tourist attraction in Telangana. It features film sets, theme parks, live shows, gardens, and entertainment zones. Families and group travelers coming from Mumbai often include it in their itinerary for a full-day entertainment experience."
  },
  {
    "title": "Hyderabad – Birla Mandir",
    "description": "Birla Mandir is a beautiful white marble temple dedicated to Lord Venkateswara, located on a hilltop overlooking Hyderabad city. It offers a peaceful spiritual environment along with panoramic views of the city, making it a popular stop for pilgrims and tourists."
  },
  {
    "title": "Hyderabad – Chowmahalla Palace",
    "description": "Chowmahalla Palace showcases the royal heritage of the Nizams of Hyderabad with elegant courtyards, grand halls, and antique collections. It reflects the luxurious lifestyle of Hyderabad’s rulers and is a key heritage attraction for travelers exploring Telangana."
  },
  {
    "title": "Hyderabad – Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing a vast collection of art, sculptures, manuscripts, and historical artifacts from different civilizations. It is a must-visit destination for culture and history lovers traveling from Mumbai."
  },
  {
    "title": "Warangal – Thousand Pillar Temple",
    "description": "The Thousand Pillar Temple in Warangal is an ancient architectural marvel built during the Kakatiya dynasty, dedicated to Lord Shiva, Vishnu, and Surya. It is known for its intricate stone carvings and historical significance, making it a key spiritual and heritage destination in Telangana."
  },
  {
    "title": "Warangal – Warangal Fort",
    "description": "Warangal Fort is a historic fort known for its massive stone gateways and ruins that reflect the glory of the Kakatiya dynasty. It offers a glimpse into Telangana’s medieval history and is a popular stop for long-distance travelers exploring the state."
  },
  {
    "title": "Nizamabad – Nizamabad Fort",
    "description": "Nizamabad Fort is a historical structure located on a hill offering panoramic views of the city. It represents the region’s rich past and is a peaceful attraction for travelers exploring northern Telangana by road from Mumbai."
  }
],






services: [
  {
    name: "Mumbai to Telangana Cab",
    description: "Mumbai to Telangana cab service offers reliable long-distance travel connecting Maharashtra to Telangana. This service is ideal for business travelers, families, and tourists. Well-maintained vehicles and experienced drivers ensure smooth highway journeys. It guarantees a safe and comfortable travel experience."
  },
  {
    name: "Mumbai to Telangana Taxi",
    description: "Mumbai to Telangana taxi provides private and convenient intercity travel with flexible schedules. This service includes door-to-door pickup and comfortable seating. Suitable for long-distance journeys. It ensures a smooth and hassle-free ride."
  },
  {
    name: "Mumbai to Telangana Cab Service",
    description: "Mumbai to Telangana cab service offers professional travel solutions with multiple vehicle options. This service is ideal for corporate trips, family travel, and group journeys. Clean vehicles and trained drivers enhance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Mumbai to Telangana Taxi Service",
    description: "Mumbai to Telangana taxi service ensures dependable transportation for long-distance travel. This service is ideal for business and personal trips. Flexible booking options make travel convenient. It guarantees a pleasant journey."
  },
  {
    name: "Cab from Mumbai to Telangana",
    description: "Cab from Mumbai to Telangana offers a convenient way to travel between states with complete comfort. This service is ideal for those preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Telangana",
    description: "Taxi from Mumbai to Telangana provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Telangana Cab Booking",
    description: "Mumbai to Telangana cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Telangana Taxi Booking Online",
    description: "Mumbai to Telangana taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Telangana Cab Price",
    description: "Mumbai to Telangana cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Telangana Taxi Fare",
    description: "Mumbai to Telangana taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Telangana One Way Cab",
    description: "Mumbai to Telangana one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Telangana Round Trip Taxi",
    description: "Mumbai to Telangana round trip taxi provides complete travel solutions including return journeys. This service is ideal for business trips and vacations. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Telangana Innova Cab",
    description: "Mumbai to Telangana Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable intercity experience."
  },
  {
    name: "Mumbai to Telangana Ertiga Cab",
    description: "Mumbai to Telangana Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Telangana Sedan Cab",
    description: "Mumbai to Telangana sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Telangana SUV Taxi",
    description: "Mumbai to Telangana SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable experience."
  }
],

tableData: [
  ["Mumbai to Telangana Cab", "Mumbai to Telangana Taxi"],
  ["Mumbai to Telangana Cab Service", "Mumbai to Telangana Taxi Service"],
  ["Cab from Mumbai to Telangana", "Taxi from Mumbai to Telangana"],
  ["Mumbai to Telangana Cab Booking", "Mumbai to Telangana Taxi Booking Online"],
  ["Mumbai to Telangana Cab Price", "Mumbai to Telangana Taxi Fare"],
  ["Mumbai to Telangana One Way Cab", "Mumbai to Telangana Round Trip Taxi"],
  ["Mumbai to Telangana Innova Cab", "Mumbai to Telangana Ertiga Cab"],
  ["Mumbai to Telangana Sedan Cab", "Mumbai to Telangana SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Telangana Cab Service",
    WhyChoosedescription: "Royal Route Cabs offers dependable Mumbai to Telangana cab service for long-distance travel, business trips, and family journeys."
  },
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Coverage Across Telangana Cities",
    WhyChoosedescription: "We provide cab services from Mumbai to Hyderabad, Warangal, Karimnagar, Nizamabad, and other major cities in Telangana."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel packages as per your travel plan."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Telangana cab service operates 24/7, allowing flexible departure anytime."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for Mumbai to Telangana cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Telangana cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Telangana for one-way and round trips." },
  { question: "Which Telangana cities do you cover?", answer: "We cover Hyderabad, Warangal, Karimnagar, Nizamabad, and other nearby locations." },
  { question: "What is the distance between Mumbai and Telangana?", answer: "Mumbai to Hyderabad is approximately 700 to 750 km and takes around 12 to 15 hours depending on route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, both one-way and round-trip options are available." },
  { question: "Do you provide interstate permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance routes." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajeshwar Rao",
    feedback: "The Mumbai to Telangana journey with Royal Route Cabs was very smooth and well-managed. The driver was experienced and ensured a safe long-distance travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Lakshmi Reddy",
    feedback: "Very comfortable ride from Mumbai to Telangana. The cab was clean, and the service was punctual and reliable throughout the entire journey.",
    rating: 5
  }
];









  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Telangana Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-telangana-cab.jpg", // replace if needed
  "description": "Book Mumbai to Telangana cab service with Royal Route Cabs for safe, reliable, and comfortable long-distance travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 intercity taxi service at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-telangana-cab-service"
  }
};







  return (
    <div>

<Helmet>
  <title>Mumbai to Telangana Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Telangana cab service with Royal Route Cabs. Safe and affordable long-distance taxi with sedan, SUV, Innova & Ertiga cars. 24x7 reliable intercity travel."
  />

  <meta
    name="keywords"
    content="mumbai to telangana cab, mumbai to telangana taxi, mumbai to telangana cab service, mumbai to telangana taxi service, cab from mumbai to telangana, taxi from mumbai to telangana, mumbai to telangana cab booking, mumbai to telangana taxi booking online, mumbai to telangana cab price, mumbai to telangana taxi fare, mumbai to telangana one way cab, mumbai to telangana round trip taxi, mumbai to telangana innova cab, mumbai to telangana ertiga cab, mumbai to telangana sedan cab, mumbai to telangana suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitotelanganacabservice;